// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3saa3","rootNoMargin":"styles_rootNoMargin__1MPHt"};